var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpcomingEvents(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 79,
    viewBox: "0 0 149 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.02441 2C5.88825 2.50566 11.7292 5.04989 12.0255 5.86459C12.6719 7.64218 9.54435 11.3338 8.04888 12.0815",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7158 7.54443H117.433",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50391 34.7646C5.17698 36.7386 8.55283 37.2033 8.55283 40.5615C8.55283 42.9479 4.08992 45.1689 2.50391 46.3584",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2036 43.3343C31.4579 42.3333 35.647 42.3262 40.0016 42.3262C50.5685 42.3262 61.1355 42.3262 71.7024 42.3262C90.6426 42.3262 109.583 42.3262 128.523 42.3262",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 66.0176C3.51271 67.1982 5.13343 68.0665 6.53669 69.3221C7.09575 69.8223 8.18251 69.2022 8.44099 70.1622C8.78723 71.4483 3.39565 75.2658 2.50408 76.6032",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6997 74.5869C32.256 75.7826 37.4663 76.0852 43.1662 76.0991C60.0339 76.1405 76.9022 76.0991 93.77 76.0991C111.571 76.0991 129.373 76.0991 147.174 76.0991",
    stroke: "#FB7C51",
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpcomingEvents);
export default __webpack_public_path__ + "static/media/upcomingEvents.34c0705b6cabd9eef19bece05f5c88fb.svg";
export { ForwardRef as ReactComponent };